import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot } from "firebase/firestore";

export default function PropietarioPersonal({ usuarioLogueado }) {
  const [personalEdificio, setPersonalEdificio] = useState([]);

  useEffect(() => {
    const edificioId = usuarioLogueado?.edificioId || usuarioLogueado?.edificio;
    const nombreColeccionPersonal = edificioId ? `personal_${edificioId}` : 'personal';

    const unsubscribe = onSnapshot(collection(db, nombreColeccionPersonal), (snapshot) => {
      const lista = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setPersonalEdificio(lista);
    });
    return () => unsubscribe();
  }, [usuarioLogueado]);

  return (
    <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '20px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)', boxSizing: 'border-box', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      
      {/* Encabezado Principal */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
        <div style={{ backgroundColor: '#e0f2fe', color: '#0284c7', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', boxShadow: '0 4px 6px -1px rgba(2, 132, 199, 0.2)', flexShrink: 0 }}>
          👷
        </div>
        <h3 style={{ margin: 0, color: '#0f172a', fontSize: '1.25rem', fontWeight: '800', wordBreak: 'break-word' }}>
          Personal Asignado al Edificio
        </h3>
      </div>
      <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '20px', lineHeight: '1.5' }}>
        Conoce al equipo encargado de la seguridad, mantenimiento y servicios de tu edificio bajo los estándares de <strong>MMD&amp;L Edificios SAC</strong>.
      </p>

      {personalEdificio.length === 0 ? (
        <div style={{ backgroundColor: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '12px', padding: '30px 15px', textAlign: 'center', color: '#64748b', boxSizing: 'border-box' }}>
          <span style={{ fontSize: '2rem', display: 'block', marginBottom: '10px' }}>📭</span>
          <p style={{ margin: 0, fontStyle: 'italic', fontSize: '0.9rem' }}>No hay personal registrado en este edificio todavía.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '15px' }}>
          {personalEdificio.map(p => (
            <div 
              key={p.id} 
              style={{ 
                backgroundColor: '#ffffff', 
                border: '1px solid #e2e8f0', 
                borderRadius: '12px', 
                padding: '16px', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '14px', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -2px rgba(0, 0, 0, 0.02)',
                boxSizing: 'border-box',
                overflow: 'hidden'
              }}
            >
              <img
                src={p.fotoUrl}
                alt={p.nombre}
                style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', flexShrink: 0 }}
                onError={(e) => { e.target.src = 'https://via.placeholder.com/150'; }}
              />
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <h4 style={{ margin: '0 0 4px 0', color: '#0f172a', fontSize: '0.95rem', fontWeight: '700', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                  {p.nombre}
                </h4>
                <p style={{ margin: '0 0 6px 0', color: '#0284c7', fontWeight: '700', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.5px', wordBreak: 'break-word' }}>
                  {p.cargo}
                </p>
                <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem' }}>
                  DNI: <span style={{ fontFamily: 'monospace', fontWeight: '700', color: '#334155' }}>{p.dni}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}